export default __webpack_public_path__ + "static/media/a037-8.a35b17a2.svg";